import React from 'react';
import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import TablePreRender from '../../components/Table/Table.prerender';
import FiveStarRating from '../../components/FiveStarRating/FiveStarRating';

import styles from './OverallMorningStarRating.css';
import {
    ETF_OVERALL_MORNINGSTAR_RATING,
    OVERALL_MORNINGSTAR_RATING
} from './queries';
import { displayShortDateOrNA, NA_DEFAULT } from '../../utils/Format/Format';
import {
    /* generalizeFund , */ isUnsupportedByMorningstar /* , isTacked */
} from '../../utils/fund-info';
import NavScrollContext from '../../components/PageNavigation/navigation-context';
import { overallMorningStarRatingUtil } from './util';

const OverallMorningStarRating = (props) => {
    const { etf, ticker /* , iClass */ } = props;

    return (
        <div className="section-container">
            <Card>
                <TitleWithDescription title="Morningstar" />
                <GqlQueryWrapper
                    query={
                        etf
                            ? ETF_OVERALL_MORNINGSTAR_RATING
                            : OVERALL_MORNINGSTAR_RATING
                    }
                    // dataFunc={generalizeFund}
                    dataFunc={overallMorningStarRatingUtil}
                    variables={{ ticker }}
                    placeholder={() => <TablePreRender height="10px" />}
                >
                    {({ data: { mstarData, hasTacked } }) => (
                        <React.Fragment>
                            <div className="overall-card-top">
                                <div>
                                    <div className="row">
                                        <div className="left">
                                            <div>
                                                <div className="m-header">
                                                    OVERALL MORNINGSTAR RATING
                                                </div>
                                                <div className="m-body">
                                                    <div>
                                                        <FiveStarRating
                                                            value={
                                                                isUnsupportedByMorningstar(
                                                                    ticker
                                                                )
                                                                    ? 0
                                                                    : mstarData.morningStarOverallRating
                                                            }
                                                            hollow={hasTacked}
                                                        />
                                                    </div>
                                                    {mstarData.morningStarOverallQuantity &&
                                                    !isUnsupportedByMorningstar(
                                                        ticker
                                                    ) ? (
                                                        <div className="of-text">
                                                            (of
                                                            {` ${
                                                                mstarData.morningStarOverallQuantity
                                                            } `}
                                                            funds)
                                                        </div>
                                                    ) : (
                                                        <div>N/A</div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                Based on risk-adjusted returns
                                                as of{' '}
                                                {displayShortDateOrNA(
                                                    mstarData.morningStarAsOfDate
                                                )}.
                                            </div>
                                        </div>
                                        <div className="right">
                                            <div className="m-header">
                                                MORNINGSTAR CATEGORY
                                            </div>
                                            <div className="m-body">
                                                {mstarData.morningStarCategoryName
                                                    ? mstarData.morningStarCategoryName
                                                    : `${NA_DEFAULT}`}
                                            </div>
                                            <NavScrollContext.Consumer>
                                                {(scrollTo) => (
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            scrollTo(3);
                                                        }}
                                                        className="see-ratings"
                                                        href="#content-ratings-risks"
                                                    >
                                                        See 3-, 5-, and 10-year
                                                        (if applicable)
                                                        Morningstar Ratings™.
                                                    </a>
                                                )}
                                            </NavScrollContext.Consumer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="overall-card-bottom">
                                {hasTacked &&
                                    Boolean(
                                        mstarData.morningStarOverallRating
                                    ) && (
                                        <div className="hollow-morningstar-footer">
                                            Ratings displayed with hollow stars
                                            represent Morningstar Extended
                                            Performance Ratings. Morningstar
                                            provides adjusted historical returns
                                            and an Extended Performance Rating
                                            for some mutual fund share class
                                            that don{`'`}t have a 1, 3-, 5-, or
                                            10-year performance history. These
                                            hypothetical Morningstar Ratings are
                                            based on the historical performance
                                            of the oldest share class of the
                                            fund, adjusted for fees and
                                            expenses.
                                        </div>
                                    )}
                                {(!mstarData.morningStarOverallRating ||
                                    isUnsupportedByMorningstar(ticker)) && (
                                    <div>
                                        Funds must have at least three years of
                                        performance data before Morningstar will
                                        assign a star rating.<br />
                                        <br />
                                    </div>
                                )}
                                The Overall Morningstar Rating™ for a managed
                                product is derived from a weighted average of
                                the performance figures associated with its
                                three-, five-, and 10-year (if applicable)
                                Morningstar Rating metrics.<sup>*</sup>
                            </div>
                        </React.Fragment>
                    )}
                </GqlQueryWrapper>
            </Card>
            <style jsx>{styles}</style>
        </div>
    );
};

export default OverallMorningStarRating;
